import React from "react";
import { Link } from "react-router-dom";

export default function Terms() {
  const updated = "August 2, 2026";
  return (
    <main data-testid="terms-page" className="pt-28 pb-28 min-h-screen relative z-10">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <p className="overline text-[#9A7420] mb-3">Legal</p>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight mb-4">Terms &amp; Conditions</h1>
        <p className="text-[#8B8494] text-sm mb-14">Last updated {updated}</p>

        <div className="prose prose-neutral max-w-none text-[#3a3541] leading-relaxed space-y-10">
          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Acceptance</h2>
            <p>
              By using womenheaven.com or any service provided by Women Heaven Med Spa (&quot;Women Heaven,&quot; &quot;we&quot;),
              you agree to these Terms &amp; Conditions and our{" "}
              <Link to="/privacy" className="text-[#9A7420] underline">Privacy Policy</Link>. If you do not agree, please do not use the site.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Our services</h2>
            <p>
              Women Heaven offers in-person aesthetic and wellness treatments including CO2 Fractional Laser, IPL, Cupping Therapy (wet/dry/moving), PRP therapy, IV Hydration, HIFU skin lifting, Mesotherapy, and medically-guided Weight Management, as well as retail sales of Atomy skin-care products, an AI Skin Analysis tool, and free consultations. Availability and pricing are subject to change without notice.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Medical / cosmetic disclaimer</h2>
            <p>
              All services are cosmetic and wellness in nature. Nothing on this site or in any of our communications is medical advice or a medical diagnosis. Individual results vary. Please consult your licensed healthcare provider before beginning any treatment if you have a medical condition, are pregnant, or are taking medication.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Bookings, cancellations &amp; no-shows</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>All appointments require confirmation from our team.</li>
              <li>Please arrive 10 minutes before your scheduled time.</li>
              <li>To cancel or reschedule, please contact the spa at least 24 hours in advance.</li>
              <li>Late arrivals may result in a shortened session at the original price.</li>
              <li>Repeated no-shows may result in a prepaid deposit being required for future bookings.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">SMS text messages (opt-in)</h2>
            <p>
              When you book a Wet Cupping appointment on our website or by phone, you provide your mobile number and expressly agree to receive treatment-specific text messages from Women Heaven at the number you provide. By checking the SMS consent checkbox at booking, or by verbally consenting to our staff, you agree to:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Receive up to <b>two automated messages per appointment</b> — one <b>pre-care</b> message when the appointment is booked, and one <b>after-care</b> message once the appointment is completed.</li>
              <li>Standard message and data rates may apply.</li>
              <li>Consent is <b>not</b> a condition of any purchase or service.</li>
              <li>You may opt out at any time by replying <b>STOP</b> to any message. Reply <b>HELP</b> for help, or email Womenheaven@outlook.com.</li>
            </ul>
            <p className="mt-3">
              Women Heaven does not send marketing or promotional SMS. We do not sell, rent, or share phone numbers with third parties for marketing purposes. SMS delivery is handled by Twilio; SMS opt-in data is not shared with third parties or affiliates.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Product orders &amp; shipping</h2>
            <p>
              Atomy skin-care products purchased on womenheaven.com are shipped by the manufacturer, Atomy. The shipping address you provide at checkout is forwarded to Atomy so they can fulfil your order. Delivery timelines are estimates. Any product-quality issue should be raised within 14 days of delivery by emailing Womenheaven@outlook.com.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Refunds</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><b>Services</b> are non-refundable once performed. If you were unable to receive a booked service due to our error, we will reschedule at no cost or provide a service credit.</li>
              <li><b>Products</b> may be returned unopened within 14 days for a refund of the product price, less return shipping.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your login credentials. Please notify us immediately of any unauthorized access to your account.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Limitation of liability</h2>
            <p>
              To the fullest extent permitted by law, Women Heaven is not liable for indirect, incidental, or consequential damages arising from the use of this site or its services. Our total liability shall not exceed the amount you paid for the specific service or product giving rise to the claim.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Changes to these terms</h2>
            <p>
              We may update these terms from time to time. The &quot;Last updated&quot; date at the top will reflect any change. Continued use of the site after an update constitutes acceptance.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Contact</h2>
            <p>
              Women Heaven Med Spa · Santa Clarita, California ·{" "}
              <a className="text-[#9A7420] underline" href="mailto:Womenheaven@outlook.com">Womenheaven@outlook.com</a> · +1 (661) 666-8041.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
